export default "__VITE_ASSET__ac4985a9__"